import { CookiesProvider as ReactCookiesProvider } from 'react-cookie'

export const CookiesProvider = ({ children }) => {
  return <ReactCookiesProvider>{children}</ReactCookiesProvider>
}

